'use client';
import FullPageLoader from '@/components/ui/full-page-loader';
import { signOut } from '@/services/user';
import { useRouter } from 'next/navigation';
import { useCallback, useEffect } from 'react';

export default function Page() {
  const router = useRouter();

  const signOutUser = useCallback(async () => {
    const isGuardian = new URLSearchParams(window.location.search).get('portal') === 'guardian';
    await signOut().catch((): undefined => undefined);
    router.replace(isGuardian ? '/guardian/sign-in' : '/sign-in');
  }, [router]);

  useEffect(() => {
    signOutUser();
  }, [signOutUser]);

  return (
    <div className="flex items-center justify-center h-screen">
      <FullPageLoader />
    </div>
  );
}
